import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { Contact, Address } from '../definitions/Common';
import { flatLicenceTypeValues } from '../definitions/LicenceTypeValues';


const Applicant = types
    .model('Applicant', {
        id: types.optional(types.identifier, () => uuid()),

        contact: types.maybe(Contact),
        address: types.maybe(Address),

        licenseClass: types.maybe(
            types.enumeration(flatLicenceTypeValues),
        ),
        hasTakenTrainingCourses: types.maybe(types.boolean),
    });

export default Applicant;
